import { Card, Col, Popconfirm, Row, Tabs } from 'antd'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import CustomBreadCrumb from '../../../../components/Common/CustomBreadCrumb'
import Documents from '../../../../components/Common/Documents/DocumentsCont'
import History from '../../../../components/Common/History'
import NewsletterEditor from '../../../../components/Main/Newsletter/AddNewsletter/NewsletterEditor'
import NewsletterForm from '../../../../components/Main/Newsletter/NewsletterForm'
import style from '../../../../components/Sales/style.css'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CodeIcon from '../../../../elements/CodeIcon'
import CustomSpin from '../../../../elements/CustomSpin'
import Status from '../../../../elements/Status'
import { strVal } from '../../../../modules/Utils'

function AddNewsletter(props) {
  const {
    fetching,
    isNew,
    newsletter,
    actions,
    handleActions,
    isConfirmed,
    fetch,
    submitting,
    updating,
    submit,
    update,
    remove,
    removing,
    isUpdatable,
    formRef,
  } = props

  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      submit={submit}
      update={update}
      submitting={submitting || updating}
      title={'Department'}
      isNew={isNew}
      isEdit={!isNew}
    />
  )

  const Operations = ({ newsletter, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update' && a.key !== 'remove')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    if (ops.length > 0 && isConfirmed) {
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to Duplicate?`}
            onConfirm={() => handleActions('duplicate')}
            okText="Yes"
            cancelText="No">
            <a>Duplicate</a>
          </Popconfirm>
        </span>
      )
    }

    ops.push(
      <span>
        <Link target="_blank" to={`/newsletter/render/${newsletter._key}`}>
          Preview Link
        </Link>
      </span>
    )
    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  return (
    <CustomSpin spinning={fetching}>
      <Card>
        <Row className={style.pageHeader}>
          <CustomBreadCrumb
            items={[
              {
                text: 'Newsletter Campaign',
                link: '/#/newsletter',
              },
              { text: isNew ? 'New Newsletter Campaign' : newsletter.code },
            ]}
          />
          {isNew && <h2 className={style.title}>New Newsletter Campaign</h2>}
          {!isNew && (
            <Fragment>
              <Col span={17}>
                <h3 style={{ marginTop: '10px' }}>
                  <CodeIcon code={strVal(newsletter, 'code')} title={'Delivery Code'} />
                  <Status value={strVal(newsletter, 'status')} />
                  <Operations
                    style={{ marginTop: '10px' }}
                    newsletter={newsletter}
                    status={strVal(newsletter, 'status')}
                  />
                </h3>
              </Col>
              <RefreshButton onClick={fetch} />
            </Fragment>
          )}
        </Row>
      </Card>
      <Card style={{ marginTop: '20px' }}>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="form">
            <NewsletterForm ref={formRef} {...props} />
            <NewsletterEditor {...props} />
            <SubmitButton style={{ marginTop: '20px' }} />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="Documents" key="files">
            <Documents
              key={newsletter._rev}
              editable={true}
              footer={false}
              category={false}
              email={true}
              owner={newsletter}
            />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="History" key="history">
            <History owner={newsletter} key={newsletter._rev} isArray={true} />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddNewsletter
